export default __webpack_public_path__ + "static/media/tpp-pet-store-discount.b4cd7aff.svg";